import { useGuestStore } from '@host/stores';

/**
 * Utility function to detect if the current user is a guest
 * Uses multiple methods to reliably detect guest status
 */
export function isCurrentUserGuest(): boolean {
  try {
    // Check guest store state first (most reliable)
    const guestState = useGuestStore.getState();
    if (guestState.guest && guestState.token) {
      return true;
    }

    // Check for guest token in localStorage as backup
    const guestToken = localStorage.getItem('guestToken');
    if (guestToken) {
      return true;
    }

    // Check if we have visit details (indicates guest session)
    if (guestState.visitDetails !== null) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error checking if current user is guest:', error);
    return false;
  }
}

/**
 * Get the appropriate user type for API requests based on current user status
 */
export function getUserTypeForApiRequest(): 'PlatformUser' | 'GuestUser' {
  return isCurrentUserGuest() ? 'GuestUser' : 'PlatformUser';
}
